import type { PayloadAction } from 'modules/global/generic.types';
import * as types from 'modules/guidelines/actionTypes';
import type { Guideline, GuidelineByGuidelineIdState } from 'modules/guidelines/types';
import type { DeleteGuidelineSuccessAction } from 'modules/guidelines/types/actions';
import { createReducer } from 'utils/ReduxUtils';

const initialState: GuidelineByGuidelineIdState = {};

const updateGuideline = (state: GuidelineByGuidelineIdState, guideline: Guideline): GuidelineByGuidelineIdState => ({
  ...state,
  [guideline.guidelineId]: {
    ...(state[guideline.guidelineId] ?? {}),
    [guideline.id]: guideline.version,
  },
});

const updateGuidelines = (
  state: GuidelineByGuidelineIdState,
  { payload }: PayloadAction<{ content: Guideline[] }>
): GuidelineByGuidelineIdState => payload.content.reduce(updateGuideline, state);

const updateGuidelineFromAction = (
  state: GuidelineByGuidelineIdState,
  { payload: guideline }: PayloadAction<Guideline>
): GuidelineByGuidelineIdState => updateGuideline(state, guideline);

const removeGuideline = (
  state: GuidelineByGuidelineIdState,
  { payload: guidelineId }: DeleteGuidelineSuccessAction
): GuidelineByGuidelineIdState => {
  const { [guidelineId]: _omitted, ...newState } = state;
  return newState;
};

export default createReducer<GuidelineByGuidelineIdState>(initialState, {
  [types.FIND_GUIDELINES_DEALER_OR_GROUP_SUCCESS]: updateGuidelines,
  [types.FETCH_GUIDELINES_SUCCESS]: updateGuidelines,
  [types.PUT_GUIDELINE_SUCCESS]: updateGuidelineFromAction,
  [types.POST_GUIDELINE_SUCCESS]: updateGuidelineFromAction,
  [types.FETCH_GUIDELINE_SUCCESS]: updateGuidelineFromAction,
  [types.ASSIGN_BRANDS_TO_GUIDELINE_SUCCESS]: updateGuidelineFromAction,
  [types.POST_CLONE_GUIDELINE_SUCCESS]: updateGuidelineFromAction,
  [types.DELETE_GUIDELINE_SUCCESS]: removeGuideline,
});
